module.exports = __webpack_public_path__ + "static/media/Jia Gao.8375b0e1.png";